export default __webpack_public_path__ + "static/media/Onboarding2.5c4885e8.gif";